import { RootState } from "store/store";
import { connect } from "react-redux";
import {
    getActiveStep,
    getEnrollId,
} from "store/environments/tenants/enroll-tenant/enroll-tenant-selectors";
import { setActiveStepData } from "store/environments/tenants/enroll-tenant/enroll-tenant-actions";
import SelectCustomer from "./SelectCustomer";
import { setIsUnsavedChangeAvailable } from "store/common/unsaved-data/unsaved-data-actions";
import { fetchCustomersWithoutLoader } from "store/customers/customers-thunks";
import { getCustomers } from "store/customers/customers-selectors";
import { getReservedTenantNames } from "store/environments/tenants/tenants-selectors";
import { fetchTenantsWithoutLoader } from "store/environments/tenants/tenants-thunks";
import { getActiveEnvironmentMoniker } from "store/environments/environment-selectors";
import withLoader from "hocs/withLoader/withLoader";
import { compose } from "redux";

const mapStateToProps = (state: RootState) => ({
    activeStep: getActiveStep(state),
    customers: getCustomers(state),
    orchestratorInstanceId: getEnrollId(state),
    reservedTenantNames: getReservedTenantNames(state),
    activeEnvMoniker: getActiveEnvironmentMoniker(state),
});
const SelectCustomerContainer = compose(
    connect(mapStateToProps, {
        setActiveStepData,
        setIsUnsavedChangeAvailable,
        fetchCustomers: fetchCustomersWithoutLoader,
        fetchTenants: fetchTenantsWithoutLoader,
    }),
    withLoader
)(SelectCustomer);

export default SelectCustomerContainer;
